export function buildTeamMap(teams) {
  const m = {};
  (teams || []).forEach((t) => { m[t.id] = t; });
  return m;
}

export function teamLabel(match, side, teamMap) {
  const id = side === "a" ? match.team_a_id : match.team_b_id;
  const ph = side === "a" ? match.team_a_placeholder : match.team_b_placeholder;
  if (id && teamMap[id]) return teamMap[id].name;
  return ph || "TBD";
}

export function teamObj(match, side, teamMap) {
  const id = side === "a" ? match.team_a_id : match.team_b_id;
  return id ? teamMap[id] : null;
}

function interval(m, durationMin) {
  if (!m.scheduled_time) return null;
  const start = new Date(m.scheduled_time).getTime();
  const end = start + durationMin * 60000;
  return [start, end];
}

function overlaps(a, b) {
  return a && b && a[0] < b[1] && b[0] < a[1];
}

export function computeWarnings(matches, teamMap, refMap, durationMin) {
  const warnings = [];
  const active = matches.filter((m) => m.scheduled_time && m.status !== "final");
  for (let i = 0; i < active.length; i++) {
    for (let j = i + 1; j < active.length; j++) {
      const a = active[i], b = active[j];
      const ia = interval(a, durationMin), ib = interval(b, durationMin);
      if (!overlaps(ia, ib)) continue;
      // same field
      if (a.field_id && a.field_id === b.field_id) {
        warnings.push({ type: "field", message: "Field double-booked at the same time.", ids: [a.id, b.id] });
      }
      // shared team
      const teamsA = [a.team_a_id, a.team_b_id].filter(Boolean);
      const teamsB = [b.team_a_id, b.team_b_id].filter(Boolean);
      const sharedTeam = teamsA.find((t) => teamsB.includes(t));
      if (sharedTeam) {
        warnings.push({ type: "team", message: `${teamMap[sharedTeam]?.name || "A team"} has two matches at once.`, ids: [a.id, b.id] });
      }
      // shared referee
      if (a.referee_id && a.referee_id === b.referee_id) {
        warnings.push({ type: "referee", message: `${refMap[a.referee_id] || "A referee"} has two matches at once.`, ids: [a.id, b.id] });
      }
    }
  }
  return warnings;
}
